var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Actions from '../../actions/fuse/settings.actions';
import * as _ from 'lodash';
import FuseDefaultSettings from '../../../fuse-configs/fuseDefaultSettings';
import FuseLayouts from '../../../theme/layout/layouts';
var initialState = {
    defaults: _.merge({}, FuseDefaultSettings),
    current: _.merge({}, FuseDefaultSettings),
};
var settings = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case Actions.SET_SETTINGS: {
            return __assign(__assign({}, state), { current: _.merge({}, state.current, action.value && action.value.layout && action.value.layout.style
                    ? { layout: { config: FuseLayouts[action.value.layout.style].defaults } }
                    : {}, action.value) });
        }
        case Actions.SET_DEFAULT_SETTINGS: {
            return __assign(__assign({}, state), { defaults: _.merge({}, state.defaults, action.value), current: _.merge({}, state.defaults, action.value && action.value.layout && action.value.layout.style
                    ? { layout: { config: FuseLayouts[action.value.layout.style].defaults } }
                    : {}, action.value) });
        }
        case Actions.RESET_DEFAULT_SETTINGS: {
            return __assign(__assign({}, state), { defaults: _.merge({}, state.defaults), current: _.merge({}, state.defaults) });
        }
        default: {
            return state;
        }
    }
};
export default settings;



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/fuse/settings.reducer.ts
// module id = 1166
// module chunks = 81